module.exports = __webpack_public_path__ + "static/media/Pitts-photo.7f4e18c0.PNG";